<template>
  <div :class="classes">
    <pt-page-title title="提现详情"></pt-page-title>
    <pt-sub-title title="用户信息"></pt-sub-title>
    <template>
      <div :class="$style['pt-withdraw-detail']">
        <table>
          <tr>
            <td>付款请求流水号：</td>
            <td>{{withdrawal_detail.serialNumber}}</td>
          </tr>
          <tr>
            <td>生命银行用户：</td>
            <td>{{user.firstName}}</td>
          </tr>
          <tr>
            <td>C端手机号：</td>
            <td>{{user.mobile}}</td>
          </tr>
          <tr>
            <td>所在地：</td>
            <td>{{user.city}}</td>
          </tr>
          <!-- <tr>
            <td>所属区域：</td>
            <td></td>
          </tr> -->
        </table>
      </div>
    </template>
    <pt-sub-title title="提现信息"></pt-sub-title>
    <template>
      <div :class="$style['pt-withdraw-detail']">
        <table>
          <tr>
            <td>提现方式：</td>
            <td>{{withdrawal_detail.withdrawalsChannel === 'WXPAY'?'微信零钱':'银行卡'}}</td>
          </tr>
          <tr v-if="withdrawal_detail.withdrawalsChannel !== 'WXPAY'">
            <td>收款方账户名称：</td>
            <td>{{bankAccount.accountName}}</td>
          </tr>
          <tr>
            <td>身份证号：</td>
            <td>{{withdrawal_detail.withdrawalsChannel === 'WXPAY'?withdrawal_detail.wxWithdrawalsAccount.idCard:bankAccount.idCard}}</td>
          </tr>
          <tr v-if="withdrawal_detail.withdrawalsChannel !== 'WXPAY'">
            <td>银行预留手机号：</td>
            <td>{{bankAccount.mobile}}</td>
          </tr>
          <tr v-if="withdrawal_detail.withdrawalsChannel !== 'WXPAY'">
            <td>开户银行：</td>
            <td>{{bankAccount.bankName}}</td>
          </tr>
          <tr v-if="withdrawal_detail.withdrawalsChannel !== 'WXPAY'">
            <td>开户行全称：</td>
            <td>{{bankAccount.branchName}}{{bankAccount.bankName}}</td>
          </tr>
          <tr v-if="withdrawal_detail.withdrawalsChannel !== 'WXPAY'">
            <td>收款账户：</td>
            <td>{{bankAccount.cardNumber}}</td>
          </tr>
          <tr>
            <td>提现金额：</td>
            <td>¥{{withdrawal_detail.withdraw_amount}}</td>
          </tr>
          <tr>
            <td>实际金额：</td>
            <td>¥{{withdrawal_detail.withdraw_actualAmount}}</td>
          </tr>
          <tr>
            <td>提现时间：</td>
            <td>{{withdrawal_detail.withdraw_date}}</td>
          </tr>
          <tr>
            <td>状态：</td>
            <td>{{withdrawal_detail.withdraw_status}}</td>
          </tr>
          <template v-if="withdrawal_detail.status!=='WAITING_FOR_APPROVAL'">
          <tr>
            <td>审核人：</td>
            <td>{{withdrawal_detail.operatorName}}</td>
          </tr>
          <tr>
            <td>审核时间：</td>
            <td>{{withdrawal_detail.operator_date}}</td>
          </tr>
          </template>
          <tr>
            <td>回退状态：</td>
            <td>{{withdrawal_detail.hasRolledBack?'已回退':(withdrawal_detail.canRollBackBalance?'可回退':"--")}}</td>
          </tr>
          <tr>
            <td v-if="withdrawal_detail.status!=='PROCESSING'||withdrawal_detail.status!=='WAITING_FOR_APPROVAL'">
              {{withdrawal_detail.status==='REJECT'?"驳回原因：":"提现描述："}}</td>
            <td>{{withdrawal_detail.statusDescription}}</td>
          </tr>
        </table>
      </div>
    </template>
    <el-button type="primary" @click="toWithdraw" v-if="withdrawal_detail.status==='WAITING_FOR_APPROVAL'" :loading="completeLoading">审核通过</el-button>
    <el-button type="primary" plain @click="rejectWithdraw" v-if="withdrawal_detail.status==='WAITING_FOR_APPROVAL'" :loading="completeLoading">驳回</el-button>
     <el-button type="primary" @click="returnWithdraw" v-if="isReturnWithdraw" :loading="returnLoading">回退</el-button>
    <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['review-coupon-dialog']" @close="closeDialog">
      <audit-review v-if="is_reject" @closeDialog="closeDialog" :ids="selectIds"></audit-review>
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import auditReview from '../audit-review'
const prefixCls = 'pt-withdraw-detail'

export default {
  name: 'pt-withdraw-detail',
  components: {
    auditReview
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    user () {
      return this.withdrawalDetail.user || {}
    },
    bankAccount () {
      return this.withdrawalDetail.bankAccount || {}
    },
    is_dialog () {
      return this.is_reject
    },
    isReturnWithdraw () {
      return this.withdrawalDetail.status === 'FAILED' && this.withdrawalDetail.canRollBackBalance
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    withdrawalDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    completeLoading: {
      type: Boolean,
      default: false
    },
    returnLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      withdrawal_detail: this.withdrawalDetail,
      is_reject: false,
      selectIds: [],
      dialog_title: '提现驳回'
    }
  },
  watch: {
    withdrawalDetail: {
      handler: function (val) {
        this.withdrawal_detail = val
      }
    }
  },
  methods: {
    returnWithdraw () {
      this.$emit('addUserWalletBalance')
    },
    rejectWithdraw () {
      this.selectIds.push(this.withdrawalDetail.id)
      this.is_reject = true
    },
    closeDialog (val) {
      if (val) {
        this.$emit('getWithdrawalDetail')
      }
      this.is_reject = false
    },
    toWithdraw () {
      this.$confirm('确定审核通过该提现记录吗', '提现审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('withdrawalComplete')
      })
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  @import "~less/var.less";

  :global {
    .pt-withdraw-detail {
      .el-checkbox+.el-checkbox {
        margin-left: 0
      }

      .wt-box {
        justify-content: flex-start;
        margin-left: -1rem
      }

      .wt-box__item {
        margin-right: .5rem
      }
    }

  }

  .pt-withdraw-detail {

    padding: 0 20px;
    display: flex;
    flex-direction: row;

    :global table {
      tr {
        td {
          line-height: 40px;
          font-size: 16px;
        }

        :first-child {
          width: 1.3rem;
          display: -webkit-box;
          color: @mainColor;
          justify-content: flex-end;
        }
      }
    }

    .el-checkbox+.el-checkbox {
      margin: 0
    }
  }

</style>
